import React from 'react';

function StatCard({ icon, label, value, onClick }) {
  const isClickable = !!onClick;
  
  return (
    <div 
      className={`bg-white rounded-lg shadow p-6 ${isClickable ? 'cursor-pointer hover:shadow-lg hover:scale-105 transition-all duration-200' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 mb-1">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        <div className={isClickable ? "text-green-600" : "text-blue-600"}>{icon}</div>
      </div>
    </div>
  );
}

export default StatCard;

